import React, {useCallback, useEffect} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import PageTitle from '../shared/PageTitle';
import {Box, CircularProgress, LinearProgress} from '@mui/material';
import {ShopifySubscription} from '../../interfaces';
import ShopifySubscriptionPendingReturns from './ShopifySubscriptionPendingReturns';
import {
  getShopifySubscriptionPendingReturns,
  completeShopifySubscriptionReturn,
} from '../../api/adminAPI';

interface Props {}

const AdminPendingShopifySubscriptionReturns: React.FC<Props> = () => {
  const {t} = useTranslation();
  const [
    shopifySubscriptionPendingReturns,
    setShopifySubscriptionPendingReturns,
  ] = React.useState<ShopifySubscription[]>([]);

  const [pending, setPending] = React.useState(false);

  const fetchData = useCallback(async () => {
    const subscriptions = await getShopifySubscriptionPendingReturns();
    setShopifySubscriptionPendingReturns(subscriptions);
  }, []);

  const onCompleteReturn = useCallback(
    async (shopifySubscriptionId: number) => {
      const confirmed = window.confirm(
        'Are you sure you wish to complete this return?',
      );
      if (confirmed) {
        setPending(true);
        const res = await completeShopifySubscriptionReturn({
          shopifySubscriptionId,
        });
        setPending(false);
        if (res?.success) {
          fetchData();
        }
      }
    },
    [fetchData],
  );

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <>
      <Helmet>
        <title>{t('pages.pendingShopifySubscriptionReturn')}</title>
      </Helmet>
      <Box>
        <PageTitle>{t('pages.pendingShopifySubscriptionReturn')}</PageTitle>
        <Box sx={{display: 'flex', justifyContent: 'center', mb: 2}}>
          {pending && <CircularProgress />}
        </Box>
        <ShopifySubscriptionPendingReturns
          shopifySubscriptions={shopifySubscriptionPendingReturns ?? []}
          onCompleteReturn={onCompleteReturn}
        />
      </Box>
    </>
  );
};

export default React.memo(AdminPendingShopifySubscriptionReturns);
